<template>
  <div>
    <v-speed-dial
      v-model="fab"
      bottom
      right
      :transition="transition"
      fixed
      v-if="$vuetify.breakpoint.smAndDown"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" :color="color" dark fab>
          <v-icon v-if="fab"> mdi-close </v-icon>
          <v-icon v-else> mdi-plus </v-icon>
        </v-btn>
      </template>

      <div class="main-container">
        <div class="btn-container">
          <v-btn class="main-text" @click="setStaffDialog(true)">
            Filter By Staff
          </v-btn>
          <v-btn fab dark small :color="color">
            <v-icon dense>mdi-account-group-outline</v-icon>
          </v-btn>
        </div>
        <div class="btn-container" v-if="displayElemsOnStaff()">
          <v-btn class="main-text" @click="setHouseDialog(true)">
            Filter By Program
          </v-btn>
          <v-btn fab dark small :color="color">
            <v-icon dense>mdi-view-week-outline</v-icon>
          </v-btn>
        </div>
        <div class="btn-container" v-if="displayElemsOnStaff()">
          <v-btn class="main-text" @click="setClientDialog(true)">
            Filter By Client
          </v-btn>
          <v-btn fab dark small :color="color">
            <v-icon dense>mdi-account-group-outline</v-icon>
          </v-btn>
        </div>
        <div class="btn-container" v-if="displayElemsOnStaff()">
          <v-btn class="main-text" @click="showAdd"> Add Shift </v-btn>
          <v-btn fab dark small :color="color">
            <v-icon dense>mdi-calendar-plus</v-icon>
          </v-btn>
        </div>
      </div>
    </v-speed-dial>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      fab: false,
      transition: "slide-y-reverse-transition",
      color: "indigo darken-4",
      fav: true,
      menu: false,
      userRole: localStorage.getItem("userRole"),
    };
  },

  methods: {
    ...mapMutations("shifts", {
      setHouseDialog: "SET_HOUSE_DIALOG",
      setStaffDialog: "SET_STAFF_DIALOG",
      setClientDialog: "SET_CLIENT_DIALOG",
      setAddShiftDialog: "SET_ADD_SHIFT_DIALOG",
    }),

    showAdd() {
      this.$router.push({
        path: `/shifts/add-shift`,
        query: { newUser: "true" },
      });
    },

    displayElemsOnStaff() {
      let staffs = ["Direct Care Staff"];

      return this.userRole.includes(staffs) ? false : true;
    },
  },
};
</script>

<style scoped>
.main-container {
  display: flex;
  flex-direction: column;
  margin-right: 130px;
}

.main-text {
  min-width: 0;
  max-width: 100%;
  margin: 0;
  align-self: center;
  padding: 8px;
  border-radius: 4px;
  color: #ffffff;
  background-color: #404753 !important;
}

.btn-container {
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
  align-items: stretch;
  border-radius: 16px;
}
</style>
